import { gql } from '@apollo/client'

export const GET_ALL_JUSTIFICATIONS_EMPLOYEES = gql`
  query GetAllEmployeeJustifications(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllEmployeeJustifications(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        employee_id
        log_id
        justification_type
        description
        document_url
        justification_date
        status
        justification_type_spanish
      }
    }
  }
`

export const GET_ONE_JUSTIFICATION_EMPLOYEE_BY_ID = gql`
  query GetEmployeeJustificationById($getEmployeeJustificationByIdId: Int!) {
    getEmployeeJustificationById(id: $getEmployeeJustificationByIdId) {
      id
      employee_id
      log_id
      justification_type
      description
      document_url
      justification_date
      status
      justification_type_spanish
    }
  }
`

export const REGISTER_JUSTIFICATION_EMPLOYEE = gql`
  mutation CreateEmployeeJustification($input: employeeJustificationsInput!) {
    createEmployeeJustification(input: $input)
  }
`

export const UPDATE_JUSTIFICATION_EMPLOYEE = gql`
  mutation UpdateEmployeeJustification(
    $input: employeeJustificationsInput!
    $updateEmployeeJustificationId: Int!
  ) {
    updateEmployeeJustification(
      input: $input
      id: $updateEmployeeJustificationId
    )
  }
`

export const DELETE_JUSTIFICATION_EMPLOYEE = gql`
  mutation DeleteEmployeeJustification($deleteEmployeeJustificationId: Int!) {
    deleteEmployeeJustification(id: $deleteEmployeeJustificationId)
  }
`
export const GET_TYPES_OF_JUSTIFICATIONS = gql`
  query GetTypesOfJustifications {
    getTypesOfJustifications {
      value
      label
    }
  }
`

export const GET_STATUS_OF_JUSTIFICATIONS = gql`
  query GetStatusOfJustifications {
    getStatusOfJustifications {
      value
      label
    }
  }
`
